import { CustomLessonCountForClass } from 'shared/api/resources'
import { doAdminQueries } from 'infrastructure/api'
import { atomFamily } from 'jotai/utils'
import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'

async function fetchCustomLessonCountForClass(classId: number) {
  return doAdminQueries<number>([
    {
      resourceData: CustomLessonCountForClass,
      params: {
        class_id: classId,
      },
    },
  ])
}

export const customLessonCountForClassAtomFamily = atomFamily(
  (classId: number) =>
    atomWithRefresh(async () => {
      const response = await fetchCustomLessonCountForClass(classId)
      return response.data[CustomLessonCountForClass.key] ?? 0
    }),
)
